import type { CSSProperties } from 'react'
import { COLORS, FONT } from '../../styles/tokens'
import LineChart, { type ChartSeries } from '../charts/LineChart'
import { CATEGORY_COLORS, ACTIVITY_COLOR_DEFAULT } from '../charts/activityColors'

interface CategoryEvolutionChartProps {
  categoryEvolution: Record<string, { date: string; avgScore: number }[]>
  visibleCategories: Set<string>
  categoryLabel:     (cat: string) => string
  noDataLabel:       string
  language:          string
}

export default function CategoryEvolutionChart({
  categoryEvolution,
  visibleCategories,
  categoryLabel,
  noDataLabel,
  language,
}: CategoryEvolutionChartProps) {
  const allCategories = Object.keys(categoryEvolution)

  const chartSeries: ChartSeries[] = []
  for (const cat of allCategories) {
    if (!visibleCategories.has(cat)) continue
    const evolution = categoryEvolution[cat]
    if (evolution.length === 0) continue
    chartSeries.push({
      id:    cat,
      label: categoryLabel(cat),
      color: CATEGORY_COLORS[cat] ?? ACTIVITY_COLOR_DEFAULT,
      data:  evolution.map(e => ({ x: e.date, y: e.avgScore })),
    })
  }

  const locale = language === 'es' ? 'es-ES' : 'en-US'

  return chartSeries.length > 0 ? (
    <LineChart
      series={chartSeries}
      formatX={(x) => {
        const d = new Date(x + 'T00:00:00')
        return d.toLocaleDateString(locale, { day: 'numeric', month: 'short' })
      }}
      formatY={(y) => y.toLocaleString()}
      yUnit=" pts"
      noData={noDataLabel}
    />
  ) : (
    <p style={s.emptyMsg}>{noDataLabel}</p>
  )
}

const s: Record<string, CSSProperties> = {
  emptyMsg: {
    fontSize:   FONT.size.md,
    color:      COLORS.textSecondary,
    fontWeight: 500,
    fontStyle:  'italic',
    textAlign:  'center' as const,
    padding:    '24px 0',
    margin:     0,
  },
}
